export default __webpack_public_path__ + "static/media/hht2_ep06_timeline_q01_b.cee2eca2.png";